module.exports = __webpack_public_path__ + "media/flags/vc-cd4d4bc7.svg";